import { PropTypes } from "prop-types";
import React, { useEffect, useState } from "react";
import { NOOP_UNDEFINED } from "~/constants/callbacks";
import { CONTACT_OWNER_OPTION } from "~/constants/dropdowns/ContactOwnerOption";
import { apiFetch } from "~/lib/fetchClient";
import Select from "./SelectWrapper/Select";

const TeamEmailsSelect = ({
  id = "",
  name = "",
  value = "",
  placeholder = "Select Email",
  onChange = NOOP_UNDEFINED,
  isMulti = false,
  isInvalid = false,
  isClearable = false,
  isSearchable = false,
  addBlank = false,
  contactOwner = false,
}) => {
  const [options, setOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    let aborted = false;
    const req = apiFetch.get("/team/teammates_options");

    const fetchData = async () => {
      setIsLoading(true);
      try {
        const body = await req;
        const fetchedOptions = body.data.map((u) => ({
          label: `${u.name} <${u.email}>`,
          value: u.email,
        }));

        if (contactOwner) {
          fetchedOptions.unshift(CONTACT_OWNER_OPTION);
        }
        setOptions(fetchedOptions);
      } catch {
        // silenced
      } finally {
        if (!aborted) setIsLoading(false);
      }
    };

    fetchData();

    return () => {
      aborted = true;
      req.abort();
    };
  }, [contactOwner]);

  return (
    <Select
      validateValue
      id={id}
      name={name}
      options={options}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      addBlank={addBlank}
      isMulti={isMulti}
      isInvalid={isInvalid}
      isLoading={isLoading}
      isClearable={isClearable}
      isSearchable={isSearchable}
    />
  );
};

TeamEmailsSelect.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.array,
    PropTypes.shape({}),
  ]),
  isMulti: PropTypes.bool,
  isInvalid: PropTypes.bool,
  isClearable: PropTypes.bool,
  isSearchable: PropTypes.bool,
  addBlank: PropTypes.bool,
  contactOwner: PropTypes.bool,
};

export default TeamEmailsSelect;
